/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpRespShippingReturns_shipment$ref = any;
type PdpRespSidebarBlurbs_shipment$ref = any;
export type PdpRespContainer_shipment$ref = any;
export type PdpRespContainer_shipment = {
    readonly " $fragmentRefs": PdpRespSidebarBlurbs_shipment$ref & PdpRespShippingReturns_shipment$ref;
    readonly " $refType": PdpRespContainer_shipment$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpRespContainer_shipment",
    "type": "Shipment",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "PdpRespSidebarBlurbs_shipment",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "PdpRespShippingReturns_shipment",
            "args": null
        }
    ]
} as any);
(node as any).hash = '420fd2aa2770bf47e7c888011c42b0e9';
export default node;
